import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function SupportIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M10.2578 7.7601L11.5834 9.08573C14.0251 6.64448 17.9817 6.64448 20.4222 9.08573L21.7489 7.7601C18.5749 4.58648 13.4318 4.58648 10.2578 7.7601Z"
        fill="currentColor"
      />
      <path
        d="M28.4999 13.4999C28.4999 6.59575 22.9056 1 16 1C9.09625 1 3.50013 6.59575 3.50013 13.4999C2.11938 13.4999 1 14.6192 1 16V23.5C1 24.8808 2.11938 26.0001 3.50013 26.0001H7.25013C7.9405 26.0001 8.5 25.441 8.5 24.7499V18.5001C8.5 17.8127 8.188 16.7811 7.80662 16.21L6.00025 13.5003C6.00025 7.9765 10.477 3.50013 16.0004 3.50013C21.5253 3.50013 26.0005 7.9765 26.0005 13.5003L24.1937 16.21C23.8124 16.7811 23.5 17.8127 23.5 18.5001V25.0994C21.6678 27.1806 18.991 28.4999 16 28.4999H13.4999V31H16C20.0868 31 23.7025 29.0309 25.9829 26.0001H28.4999C29.8806 26.0001 31 24.8808 31 23.5V16C31 14.6192 29.8806 13.4999 28.4999 13.4999Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
